import { render, staticRenderFns } from "./layout-product-card-preview.vue?vue&type=template&id=055fc9a8&scoped=true&"
import script from "./layout-product-card-preview.vue?vue&type=script&lang=js&"
export * from "./layout-product-card-preview.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-card-preview.vue?vue&type=style&index=0&id=055fc9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055fc9a8",
  null
  
)

export default component.exports